<h1 matDialogTitle
    translate>
    license_expired_modal_license_expired_title
</h1>

<mat-dialog-content>
  <p translate>license_expired_modal_description</p>
  <p>
    {{ 'license_expired_modal_grace_period' | translate }}
    <ui-dateformat #gracePeriodDateFormat
                   [matTooltip]="gracePeriodDateFormat?.dataset['title']"
                   [date]="context.data.gracePeriodEndDate"
                   dateFormat="DD MMM YYYY"
                   class="grace-date"></ui-dateformat>
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close
          mat-button
          type="button">
      {{ 'modal_action_ok' | translate }}
  </button>
</mat-dialog-actions>
